import { put, call } from 'redux-saga/effects';
import { callApi } from '../apiClient';
import { callStarting, callFinished } from 'actions/apiActions';
import { logoutRequest } from 'actions/sessionActions';
import { toError } from 'shared/util/toError';


let callSequence = 0;
function* callApiSaga(method: 'GET' | 'PUT' | 'POST' | 'DELETE', endpoint: string, body?: any): any {
    const seq = ++callSequence;
    try {
        yield put(callStarting({ method, endpoint, seq, when: new Date() }));
        return yield call(callApi, method, endpoint, body);
    }
    catch (e) {
        const err = toError(e);
        if (err.message === 'FORBIDDEN') {
            yield put(logoutRequest());
        }
        throw err;
    }
    finally {
        yield put(callFinished({ seq, when: new Date() }));
    }
}

export function* apiGet(endpoint: string): any {
    return yield call(callApiSaga, 'GET', endpoint);
}

export function* apiPost(endpoint: string, body?: any): any {
    return yield call(callApiSaga, 'POST', endpoint, body);
}

export function* apiPut(endpoint: string, body: any): any {
    return yield call(callApiSaga, 'PUT', endpoint, body);
}

export function* apiDelete(endpoint: string): any {
    return yield call(callApiSaga, 'DELETE', endpoint);
}
